<roma-modal-template
  [size]="'lg'"
  [contentMinHeight]="true"
  [headerBottomMargin]="'2px'"
  (cancel)="exit()"
  [showDefaultButtons]="false"
>
  <roma-mf-settings [isModal]="true"></roma-mf-settings>
</roma-modal-template>
